import React from 'react';
import PropTypes from 'prop-types';
import ActivatableLink from './ActivatableLink';
import {makeTestId} from '../utils';

const NavLink = ({
  activeClassName,
  children,
  className,
  currentPath,
  onNavigate,
  ownedRoutes = null,
  renderOwnedLink: OwnedLink = null,
  routeName,
}) => {
  const slug = routeName.replace(/\s/g, '-').toLowerCase();
  const href = `/registry/${slug}`;
  const linkProps = {
    activeClassName,
    children,
    className,
    href,
    onClick: e => onNavigate({selection: routeName.toLowerCase()}, e),
    'data-testid': makeTestId('your-registry-header', slug),
  };

  return (
    <li>
      {ownedRoutes && ownedRoutes.test(href) ? (
        <OwnedLink {...linkProps} />
      ) : (
        <ActivatableLink currentPath={currentPath} {...linkProps} />
      )}
    </li>
  );
};

NavLink.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  activeClassName: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  routeName: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
  ownedRoutes: PropTypes.instanceOf(RegExp),
  renderOwnedLink: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.func,
  ]),
};

export default NavLink;
